module.exports = __webpack_public_path__ + "img/monitorapplication.291ac433.png";